import { FaIcon } from '@ifixit/ui/components/icon';

/**
 * An icon-tile link card for a dashboard's footer — the related-resource
 * links under the /Translate queues and the /Leaderboard ranking.
 */
export function FooterCard({
   href,
   icon,
   title,
   description,
   onClick,
}: {
   href: string;
   icon: string;
   title: string;
   description: string;
   onClick?: () => void;
}) {
   return (
      <a
         href={href}
         onClick={onClick}
         className="flex items-start gap-3 rounded-2xl border border-gray-300 bg-white p-4 no-underline hover:border-brand-500 hover:no-underline focus-visible:border-ring focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
      >
         <span className="flex size-9 shrink-0 items-center justify-center rounded-md border border-brand-200 bg-brand-100 text-brand-500">
            <FaIcon name={icon} className="size-4 fill-current" />
         </span>
         <span className="min-w-0">
            <span className="block text-base font-semibold text-gray-900">{title}</span>
            <span className="mt-1 block text-xs leading-relaxed text-gray-500">{description}</span>
         </span>
      </a>
   );
}
